import { gql } from "@apollo/client";

export const REGISTER_TRACKER_CREATE = gql`
    mutation registerTrackerCreate {
        registerTrackerCreate {
            uuid
        }
    }
`;

export const REGISTER_TRACKER_UPDATE = gql`
    mutation registerTrackerUpdate($input: TrackerUpdateInputType!) {
        registerTrackerUpdate(input: $input) {
            ok
        }
    }
`;

export const REGISTRATION_TRACKER = gql`
    mutation registrationTracker($input: RegistrationTrackerInputType) {
        registrationTracker(input: $input) {
            id
            ok
        }
    }
`;

export const SEND_TAG_EVENT = gql`
    mutation sendTagEvent($input: TagEventInputType!) {
        sendTagEvent(input: $input) {
            ok
        }
    }
`